import React, { useEffect } from 'react';
import { MapPin, X, AlertCircle, Check } from 'lucide-react';
import { useLocationPermission } from '../../hooks/useLocationPermission';

interface LocationPermissionBannerProps {
  onClose?: () => void;
}

export const LocationPermissionBanner: React.FC<LocationPermissionBannerProps> = ({ onClose }) => {
  const {
    permission,
    requestPermission,
    openSettingsGuide,
    isDenied,
    hasPermission,
    bannerDismissed,
    dismissBanner,
    resetBanner, } = useLocationPermission();

  // Auto-close when permission granted
  useEffect(() => {
    if (hasPermission && onClose) {
      onClose();
    }
  }, [hasPermission, onClose]);

  if (bannerDismissed || permission === 'granted' || permission === 'denied') {
    return null;
  }

  const handleNotNow = () => {
    dismissBanner();
    onClose?.();
  };

  const handleAllow = async () => {
    const granted = await requestPermission();
    if (granted) {
      dismissBanner();
      onClose?.();
    }
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 max-w-md mx-auto z-50">
      <div className="bg-white rounded-lg shadow-lg border border-blue-200 p-4">
        <div className="flex items-start">
          <MapPin className="h-6 w-6 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
          <div className="flex-1">
            <div className="flex justify-between items-start">
              <h3 className="font-medium text-gray-900">Enable Location Access</h3>
              {onClose && (
                <button
                  onClick={onClose}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-4 w-4" />
                </button>
              )}
            </div>
            <p className="text-sm text-gray-600 mt-1">
              Allow location access for accurate delivery tracking and faster service.
            </p>
            <div className="flex gap-3 mt-3">
              <button
                onClick={handleAllow}
                className="flex-1 bg-blue-600 text-white py-2 px-4 rounded-lg text-sm font-medium hover:bg-blue-700"
              >
                Allow Location
              </button>
              <button
                onClick={handleNotNow}
                className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg text-sm font-medium hover:bg-gray-50"
              >
                Not Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};